var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"video_link",attrs:{"href":_vm.value.link,"data-fancybox":""}},[_c('picture',{directives:[{name:"full-image-path",rawName:"v-full-image-path",value:(_vm.value.image),expression:"value.image"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }